import { ScramjetClient } from "@client/index";
import { String, Object_setPrototypeOf, Object_defineProperty } from "@/shared/snapshot";
import { carrier, carrierNative } from "@client/carrier";

export default function (client: ScramjetClient, self: Self) {
	client.Proxy("Navigator.prototype.sendBeacon", {
		apply(ctx) {
			const url = String(ctx.args[0]);
			ctx.args[0] = client.rewriteUrl(url);

			// Sent from the carrier if this frame is outside the service worker (carrier.ts).
			const via = carrier(client);
			const viaBeacon =
				via && carrierNative(via, "Navigator.prototype.sendBeacon");
			if (viaBeacon) ctx.return(viaBeacon.call(via.navigator, ...ctx.args));
		},
	});

	// fetchLater() (Chrome 135+) hands the request to the browser, which sends it when the page
	// goes away or the timeout passes, outside the service worker: straight to the site, with
	// the visitor's own address (Google's ad scripts use it for measurements). It is sent now
	// instead, as a keepalive fetch through the proxy (the page's own, hooked fetch), and the
	// result says it has been sent.
	if (typeof (self as any).fetchLater === "function") {
		client.Proxy("fetchLater", {
			apply(ctx) {
				// Never falls through to the native function: that would send the site's own address.
				const [input, init] = ctx.args;
				if (init && init.signal && init.signal.aborted)
					throw new (self as any).DOMException("signal is aborted without reason", "AbortError");
				const options: any = {};
				if (init && typeof init === "object") {
					for (const key in init) {
						if (key !== "activateAfter") options[key] = init[key];
					}
				}
				options.keepalive = true;
				// an address fetch() refuses (it throws here) is refused by fetchLater too
				(self as any).fetch(input, options).catch(() => {});
				const result: any = {};
				const Result = (self as any).FetchLaterResult;
				if (Result && Result.prototype)
					Object_setPrototypeOf(result, Result.prototype);
				Object_defineProperty(result, "activated", { get: () => true });
				ctx.return(result);
			},
		});
	}
}
